import LibraryMemberList from "@/controllers/library_member/library-member-list";

export default {
  extends: LibraryMemberList,
}
